import { Page, View, Text } from '@react-pdf/renderer';
import { styles } from './styles';
import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { globalStyles } from '../../styles';
import { useTranslation } from 'react-i18next';
import { SafeImage } from '@composites/PDF/AgendaPdfContent/components/SafeImage';

export interface MatchMakingPageProps {
  event: PublicEventDetailsResponse;
  footer: JSX.Element;
}

const MatchMakingPage = ({ event, footer }: MatchMakingPageProps) => {
  const { t } = useTranslation();

  return (
    <Page
      size={{ width: 1440, height: 800 }}
      style={{ ...styles.page, overflow: 'hidden' }}
    >
      <View
        style={{
          ...styles.leftColumn,
        }}
      >
        <Text style={{ ...styles.title }}>
          {t('match-making-&-one2one-meetings-scheduling-title-1')}
        </Text>
        <Text style={{ ...styles.title }}>
          {t('match-making-&-one2one-meetings-scheduling-title-2')}
        </Text>

        <View
          style={{
            ...globalStyles.lineBar,
            borderColor: event?.design?.themeColor ?? 'black',
            marginLeft: 0,
          }}
        />
        <View style={styles.contentWrapper}>
          <View style={styles.customGridContainer}>
            {/* First Column: 3 items */}
            <View style={styles.gridColumn}>
              {[0, 3, 6].map(index => (
                <View key={`col-1-item-${index}`} style={styles.gridItem}>
                  <Text style={styles.gridItemTitle}>
                    {t(
                      `match-making-&-one2one-meetings-scheduling-item-${index + 1}-title`
                    )}
                  </Text>
                  <Text style={styles.gridItemText}>
                    {t(
                      `match-making-&-one2one-meetings-scheduling-item-${index + 1}-text`
                    )}
                  </Text>
                </View>
              ))}
            </View>

            {/* Second Column: 2 items */}
            <View style={styles.gridColumn}>
              {[1, 4].map(index => (
                <View key={`col-2-item-${index}`} style={styles.gridItem}>
                  <Text style={styles.gridItemTitle}>
                    {t(
                      `match-making-&-one2one-meetings-scheduling-item-${index + 1}-title`
                    )}
                  </Text>
                  <Text style={styles.gridItemText}>
                    {t(
                      `match-making-&-one2one-meetings-scheduling-item-${index + 1}-text`
                    )}
                  </Text>
                </View>
              ))}
            </View>

            {/* Third Column: 3 items */}
            <View style={styles.gridColumn}>
              {[2, 5, 7].map(index => (
                <View key={`col-3-item-${index}`} style={styles.gridItem}>
                  <Text style={styles.gridItemTitle}>
                    {t(
                      `match-making-&-one2one-meetings-scheduling-item-${index + 1}-title`
                    )}
                  </Text>
                  <Text style={styles.gridItemText}>
                    {t(
                      `match-making-&-one2one-meetings-scheduling-item-${index + 1}-text`
                    )}
                  </Text>
                </View>
              ))}
            </View>
          </View>
        </View>
      </View>

      <View style={styles.rightColumn}>
        <View style={styles.imageSection}>
          {/* Left: Large Image */}
          <View style={styles.leftImageColumn}>
            <SafeImage
              src="https://media.we-conect.com/images/pdf/partnerprospectus/matchmaking_01.png"
              style={styles.largeImage}
            />
          </View>

          {/* Right: Two Small Images */}
          <View style={styles.rightImageColumn}>
            <SafeImage
              src="https://media.we-conect.com/images/pdf/partnerprospectus/matchmaking_02.png "
              style={styles.smallImageTop}
            />
            <View style={styles.smallImageSpacer} />
            <SafeImage
              src="https://media.we-conect.com/images/pdf/partnerprospectus/matchmaking_03.png"
              style={styles.smallImageBottom}
            />
          </View>
        </View>
      </View>

      {footer}
    </Page>
  );
};

export default MatchMakingPage;
